@if (showNotification$ | async) {
  <div class="sh-notification--warning">
    <div class="sh-notification__content">
      @if (notificationMsgKey$ | async; as msgKey) {
        <p class="sh-notification__msg">
          <sh-html-parser [message]="msgKey | translate"></sh-html-parser>
        </p>
      }
    </div>
    <button type="button" class="sh-pure-icon-button sh-notification__close-button" aria-label="close" (click)="onClose()">
      <svg sh-icon class="sh-icon-button__icon" [name]="'close'"></svg>
    </button>
  </div>
}
